module.exports = __webpack_public_path__ + "img/cover-about.f91cedc7.jpg";